import { Box3, Vector3 } from "three";
import type { SlotMode } from "../render/materials/slotLook";

import type { LightingSettings } from "../render/Lighting";
import type { ModelLook } from "./model/modelLook";

export const TILE_OFFSETS = [-1, 0, 1];

export const LOOK_AT_HEIGHT = 0.35;
// covers the small patch of chess squares
export const SHADOW_AREA = new Box3(new Vector3(-1.5, 0, -1.5), new Vector3(1.5, 2, 1.5));

export const BOARD_TILE_METERS = 1;
export const TILE_FOOTPRINT = 0.8 * BOARD_TILE_METERS;

export const DEFAULT_LOOK: ModelLook = { scale: 1, rotationYDegrees: 0, materials: {} };
export const PRESET_IDS = { emission: "emission", pulsingEmission: "pulsing-emission" } as const;

export const ACCEPTED_MODEL_TYPES = {
  "model/gltf-binary": [".glb"],
  "model/gltf+json": [".gltf"]
};

export const NO_CLIP = "";
export const COPIED_LABEL_MS = 1500;

export const MODE_LABELS: Record<SlotMode, string> = {
  original: "Original",
  emission: "Emission",
  pulsingEmission: "Pulsing emission"
};

export const VIEWER_LIGHTING: LightingSettings = {
  sun: { color: "#fff4e0", intensity: 2.2, direction: [3, 6, 4] },
  sky: { skyColor: "#dfe8ff", groundColor: "#3a3228", intensity: 0.4 },
  environmentIntensity: 0.45,
  shadowMapSize: 2048,
  shadowBias: -0.0005
};
